import React from 'react'
import styled from 'styled-components'
import { SCREEN_SIZE, STYLES } from '../../static/style'
import { NumberTextBox } from '../TextBox/NumberTextBox'

const StyledSchoolFeeTextBoxGroup = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
`

const FeeTextBox = styled(NumberTextBox).attrs({
  type: 'number',
})`
  margin-right: ${STYLES.GUTTER};
  width: 100%;
  ${SCREEN_SIZE.MD} {
    width: 30%;
  }
  ${SCREEN_SIZE.LG} {
    width: 20%;
  }
  ${SCREEN_SIZE.XL} {
    width: 15%;
  }
`
interface IValue {
  [key: string]: string | number
}
interface ISchoolFeeTextBoxGroupProps {
  value?: IValue
  onChange?: (v: IValue) => void
  name?: string
}

const SchoolFeeTextBoxGroup: React.FC<ISchoolFeeTextBoxGroupProps> = ({
  value = {},
  onChange,
}) => {
  const onFeeChange = (fieldValue: string | number, fieldName: string) => {
    if (onChange && value) {
      onChange({ ...value, [fieldName]: Number(fieldValue) })
    }
  }

  return (
    <StyledSchoolFeeTextBoxGroup>
      <FeeTextBox
        labelText="Kinder"
        value={value.kinder}
        onChange={(v) => onFeeChange(v, 'kinder')}
      />
      <FeeTextBox
        labelText="Year 1"
        value={value.year_1}
        onChange={(v) => onFeeChange(v, 'year_1')}
      />
      <FeeTextBox
        labelText="Year 2"
        value={value.year_2}
        onChange={(v) => onFeeChange(v, 'year_2')}
      />
      <FeeTextBox
        labelText="Year 3"
        value={value.year_3}
        onChange={(v) => onFeeChange(v, 'year_3')}
      />
      <FeeTextBox
        labelText="Year 4"
        value={value.year_4}
        onChange={(v) => onFeeChange(v, 'year_4')}
      />
      <FeeTextBox
        labelText="Year 5"
        value={value.year_5}
        onChange={(v) => onFeeChange(v, 'year_5')}
      />
      <FeeTextBox
        labelText="Year 6"
        value={value.year_6}
        onChange={(v) => onFeeChange(v, 'year_6')}
      />
      <FeeTextBox
        labelText="Year 7"
        value={value.year_7}
        onChange={(v) => onFeeChange(v, 'year_7')}
      />
      <FeeTextBox
        labelText="Year 8"
        value={value.year_8}
        onChange={(v) => onFeeChange(v, 'year_8')}
      />
      <FeeTextBox
        labelText="Year 9"
        value={value.year_9}
        onChange={(v) => onFeeChange(v, 'year_9')}
      />
      <FeeTextBox
        labelText="Year 10"
        value={value.year_10}
        onChange={(v) => onFeeChange(v, 'year_10')}
      />
      <FeeTextBox
        labelText="Year 11"
        value={value.year_11}
        onChange={(v) => onFeeChange(v, 'year_11')}
      />
      <FeeTextBox
        labelText="Year 12"
        value={value.year_12}
        onChange={(v) => onFeeChange(v, 'year_12')}
      />
    </StyledSchoolFeeTextBoxGroup>
  )
}

export { SchoolFeeTextBoxGroup }
